export type OAuthPlatform = 'lab' | 'insurer'

export interface GoogleOAuthConfig {
  platform: OAuthPlatform
  apiBaseUrl: string
  /** Post-login destination; the API keeps it only when it is safe. */
  next?: string | null
}

export interface InitOAuthResponse {
  url: string
  state: string
  expiresAt: string
}

export const initGoogleOAuth = async (
  config: GoogleOAuthConfig,
): Promise<InitOAuthResponse> => {
  const response = await fetch(
    `${config.apiBaseUrl}/v1/auth/oauth/google/init`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        platform: config.platform,
        ...(config.next ? { next: config.next } : {}),
      }),
    },
  )

  if (!response.ok) {
    throw new Error('Failed to initialize OAuth')
  }

  const data = await response.json()
  return data.data ?? data
}

export const redirectToGoogleOAuth = async (
  config: GoogleOAuthConfig,
): Promise<void> => {
  const { url } = await initGoogleOAuth(config)
  window.location.href = url
}
